import { render } from "./Settings.vue?vue&type=template&id=4c5afa7d&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./less/profileSettings.less?vue&type=style&index=0&id=4c5afa7d&scoped=true&lang=css&external"
import "../../less/_gantt_scroll.less?vue&type=style&index=1&lang=css&external"
import "./Settings.vue?vue&type=style&index=2&id=4c5afa7d&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5afa7d"]])

export default __exports__